import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4le94y2c: FaireBrandEntity = {
  token: "b_4le94y2c",
  type: "brand",
  name: "Willa Skye Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b4ead29434f1f430aa51182d07b1a18a3cefe16513ee32c81f14e2a62f7bbee.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fd221f376a2f75d9b3092fb48b0e3acda89012fcfe7e3a6608ffccdd95ae48fb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b4ead29434f1f430aa51182d07b1a18a3cefe16513ee32c81f14e2a62f7bbee.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fd221f376a2f75d9b3092fb48b0e3acda89012fcfe7e3a6608ffccdd95ae48fb.jpeg",
  location: "Costa Mesa, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Willa Skye Home was founded out of a passion for Home Decor and Textiles. It is a curated collection of luxury decorative pillow covers that brings pizazz and trend to your home in a range of styles.\n\nSince 2010, our studio in Costa Mesa, CA serves as a hub where we gather and curate fabrics. We offer a wide range of velvet colors and sizes, with the ability to create custom sizes upon request (please inquire)\n\nLoved by the editors of The Everygirl, featured in Better Homes & Gardens and HGTV magazine, Willa Skye Home is committed to elevating your living space with pieces that bring joy every time you see them.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:35.444Z",
    importedBy: "entity-db-cli",
  },
};
